import { call, cancelled, put, SagaReturnType, take } from 'redux-saga/effects';
import { buffers } from 'redux-saga';
import { setExperiment } from '../../actions/app/experiment';
import { createExperimentChannel } from '../../channels';
import type { ExperimentChannelValue } from '../../channels/experiment';

export const BUFFER_SIZE = 5;
export const buffer = buffers.sliding<ExperimentChannelValue>(BUFFER_SIZE);

export function* watchExperiment() {
  let experimentChannel: SagaReturnType<typeof createExperimentChannel>;

  try {
    experimentChannel = yield call(createExperimentChannel, buffer);

    while (true) {
      // An error from socketChannel will cause the saga jump to the catch block
      const payload: ExperimentChannelValue = yield take(experimentChannel);
      yield put(setExperiment(payload));
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Experiment channel failed. Error:', err);
  } finally {
    if (yield cancelled()) {
      experimentChannel.close();
    }
  }
}
